require("jqcloud2/dist/jqcloud.min");
require("jqcloud2/dist/jqcloud.min.css");
require("change/tag_cloud");